import React from "react";
import { ReportShell, CONTACT_ROLES } from "@/pages/reports/ReportShell";

const isoStart = () => new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10);
const isoEnd = () => new Date(new Date().getFullYear(), 11, 31).toISOString().slice(0, 10);

export const ReportClientContact = () => (
  <ReportShell
    reportKey="client-contact"
    title="Client Contact"
    subtitle="Contact roster per client, with contact role, phone, email, and address."
    filters={[
      { key: "contact_role", label: "Role", type: "select", options: CONTACT_ROLES },
      { key: "include_inactive", label: "Include Inactive", type: "boolean" },
    ]}
  />
);

export const ReportDriverAvailability = () => (
  <ReportShell
    reportKey="driver-availability"
    title="Driver Availability"
    subtitle="Drivers with availability window, qualifications, restrictions, and (permission-gated) compliance status."
    filters={[
      { key: "status", label: "Availability", type: "select",
        options: ["available", "unavailable", "on_tour", "off_duty", "hold"] },
      { key: "trailer_qualified", label: "Trailer Qualified", type: "boolean" },
      { key: "equipment", label: "Equipment", type: "text" },
      { key: "customer_restriction_kind", label: "Customer Restr", type: "select",
        options: ["blocked", "approved_only", "preferred"] },
      { key: "state", label: "State", type: "text" },
    ]}
  />
);

export const ReportDepartures = () => (
  <ReportShell
    reportKey="departures"
    title="Departures"
    subtitle="Departures schedule with pickup details, last-edited context, and L.O.T. (tour duration)."
    filters={[
      { key: "start", label: "Start", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End",   type: "date", defaultValue: isoEnd() },
    ]}
  />
);

export const ReportEndOfTour = () => (
  <ReportShell
    reportKey="end-of-tour"
    title="End of Tour"
    subtitle="Tour close-out summary with drop-off date, L.O.T., and contract context."
    filters={[
      { key: "start", label: "End From", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End To",   type: "date", defaultValue: isoEnd() },
      { key: "contract_type", label: "Contract Type", type: "select",
        options: ["all_inclusive", "non_all_inclusive", "other"] },
    ]}
  />
);

export const ReportLongTermClient = () => (
  <ReportShell
    reportKey="long-term-client"
    title="Long Term Client"
    subtitle="Customer / coach / driver relationships active within a date window."
    filters={[
      { key: "start", label: "Start", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End",   type: "date", defaultValue: isoEnd() },
    ]}
  />
);

export const ReportFleetUtilization = () => (
  <ReportShell
    reportKey="fleet-utilization"
    title="Fleet Utilization"
    subtitle="Coach & trailer utilization with (permission-gated) commercial columns."
    filters={[
      { key: "start", label: "Start", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End",   type: "date", defaultValue: isoEnd() },
    ]}
  />
);

export const ReportFuelEstimate = () => (
  <ReportShell
    reportKey="fuel-estimate"
    title="Fuel Estimate"
    subtitle="Estimated fuel cost per tour using captured or default rate ($1.50/mile). Tours missing start/end dates are excluded by default."
    filters={[
      { key: "start", label: "Start", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End",   type: "date", defaultValue: isoEnd() },
      { key: "include_missing_dates", label: "Include Tours Missing Dates", type: "boolean" },
    ]}
  />
);

export const ReportBusAvailability = () => (
  <ReportShell
    reportKey="bus-availability"
    title="Bus Availability"
    subtitle="Current availability of coaches / trailers with next known assignment."
    autoRun={true}
  />
);

export const ReportDriverTourDays = () => (
  <ReportShell
    reportKey="driver-tour-days"
    title="Driver Tour Days"
    subtitle="Days on tour + Deadhead Days aggregate per driver."
    filters={[
      { key: "start", label: "Start", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End",   type: "date", defaultValue: isoEnd() },
      { key: "include_inactive", label: "Include Inactive", type: "boolean" },
    ]}
  />
);

export const ReportDriverUtilization = () => (
  <ReportShell
    reportKey="driver-utilization"
    title="Driver Utilization"
    subtitle="Driver assignments across tours by role, coach, and duration."
    filters={[
      { key: "start", label: "Start", type: "date", defaultValue: isoStart() },
      { key: "end",   label: "End",   type: "date", defaultValue: isoEnd() },
      { key: "assignment_type", label: "Assignment Type", type: "select",
        options: ["primary_driver", "co_driver", "relief_driver"] },
    ]}
  />
);
